import { PackingTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import { MdClose, MdPrint, MdAdd, MdDelete } from "react-icons/md";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { aging, packingEntryAPI, dieMasterAPI, unitConversionAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";
import { RegistryHeader, CalculationFooter, Button } from "../../common/Shared";
import { Info, Upload, Filter as FilterIcon } from "lucide-react";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import Model from "../../common/Model";
import Filter from "../../common/Filter";

const Packing = () => {
  const getDiePdfUrl = (row) => {
    if (!row) return "";
    const pdfUrl = row.die_Pdf || row.diePdf || row.Die_Pdf;
    if (pdfUrl) return pdfUrl;

    const dieId = row.die_Id || row.dieId || row.Die_Id;
    if (dieId) {
      return `https://hline.blob.core.windows.net/hlinefiles/Extrusion/DieMedia/Pdf/${dieId}.pdf`;
    }
    return "";
  };

  const today = new Date().toISOString()?.split("T")[0];
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [agingFilters, setAgingFilters] = useState({});
  const [packingFilters, setPackingFilters] = useState({});
  const [tempFilters, setTempFilters] = useState({});
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [batchOptions, setBatchOptions] = useState([]);
  const [dieOptions, setDieOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [isManualStickerModalOpen, setIsManualStickerModalOpen] = useState(false);
  const createInitialManualStickerRow = (defaultUnitId = "", defaultUnitName = "") => ({
    bundle_No: "",
    die_Id: "",
    die_No: "",
    profile_Name: "",
    total_Pcs: "",
    total_Weight: "",
    cut_Length: "",
    unit_Conv_Id: defaultUnitId || "",
    unit_Conv_Name: defaultUnitName || "",
    wT_Per_Pcs: "",
    wT_12_FT: "",
    die_Image: "",
    withBranding: true,
  });

  const [manualStickerRows, setManualStickerRows] = useState([
    createInitialManualStickerRow(),
  ]);

  const calculateManualStickerRowValues = (row, updates, dieOptionsList, unitOptionsList) => {
    const next = { ...row, ...updates };

    const getUnit12FtConv = (unitObj) => {
      if (!unitObj) return 12;
      const label = String(unitObj.label || "").toUpperCase();
      const raw = parseFloat(unitObj.raw || 0);
      if (label.includes("INCH")) return 144;
      if (label.includes("MM")) return 3657.6;
      if (label.includes("MTR") || label.includes("METER")) return 3.6576;
      if (label.includes("FT") || label.includes("FEET")) return 12;
      if (raw > 0) {
        if (raw === 304.8) return 3657.6;
        if (raw === 12) return 144;
        if (raw === 1) return 12;
        return raw > 50 ? raw : raw * 12;
      }
      return 12;
    };

    const selectedUnit = unitOptionsList.find((u) => String(u.value) === String(next.unit_Conv_Id));
    if (selectedUnit) {
      next.unit_Conv_Name = selectedUnit.label || "";
    }

    const conv12Ft = getUnit12FtConv(selectedUnit);
    const cutLen = parseFloat(next.cut_Length || 0);
    const pcs = parseFloat(next.total_Pcs || 0);
    const totWt = parseFloat(next.total_Weight || 0);

    // A. If Die No. changed -> populate profile_Name, wT_12_FT, die_No, die_Image
    if ("die_Id" in updates) {
      if (updates.die_Id) {
        const selectedDie = dieOptionsList.find((d) => String(d.value) === String(updates.die_Id));
        if (selectedDie) {
          next.die_No = selectedDie.label || selectedDie.dieNumber || "";
          if (selectedDie.profileName) {
            next.profile_Name = selectedDie.profileName;
          }
          if (selectedDie.wt12Ft) {
            next.wT_12_FT = String(parseFloat(parseFloat(selectedDie.wt12Ft).toFixed(3)));
          }
          next.die_Image = selectedDie.dieImage || "";

          const dieWt12 = parseFloat(selectedDie.wt12Ft || 0);
          if (dieWt12 > 0 && cutLen > 0 && conv12Ft > 0) {
            const perPiece = (dieWt12 * cutLen) / conv12Ft;
            next.wT_Per_Pcs = String(parseFloat(perPiece.toFixed(3)));
            if (pcs > 0) {
              next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
            }
          }
        }
      } else {
        next.die_No = "";
        next.die_Image = "";
      }
    }

    // B. If Unit or Cut Length changed
    if ("unit_Conv_Id" in updates || "cut_Length" in updates) {
      let perPiece = parseFloat(next.wT_Per_Pcs || 0);
      if ((!perPiece || perPiece === 0) && pcs > 0 && totWt > 0) {
        perPiece = totWt / pcs;
        next.wT_Per_Pcs = String(parseFloat(perPiece.toFixed(3)));
      }
      if (perPiece > 0 && cutLen > 0 && conv12Ft > 0) {
        const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
        next.wT_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wT_12_FT;
      }
    }

    // C. If Total Weight changed manually
    if ("total_Weight" in updates) {
      if (pcs > 0 && totWt > 0) {
        const perPiece = totWt / pcs;
        next.wT_Per_Pcs = String(parseFloat(perPiece.toFixed(3)));
        if (cutLen > 0 && conv12Ft > 0) {
          const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
          next.wT_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wT_12_FT;
        }
      }
    }

    // D. If Total PCS changed
    if ("total_Pcs" in updates) {
      if (pcs > 0 && totWt > 0) {
        const perPiece = totWt / pcs;
        next.wT_Per_Pcs = String(parseFloat(perPiece.toFixed(3)));
        if (cutLen > 0 && conv12Ft > 0) {
          const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
          next.wT_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wT_12_FT;
        }
      } else if (pcs > 0 && next.wT_Per_Pcs) {
        const perPiece = parseFloat(next.wT_Per_Pcs || 0);
        next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
      }
    }

    // E. If Weight/Pcs changed manually
    if ("wT_Per_Pcs" in updates) {
      const perPiece = parseFloat(updates.wT_Per_Pcs || 0);
      if (pcs > 0 && perPiece > 0) {
        next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
      }
      if (cutLen > 0 && conv12Ft > 0 && perPiece > 0) {
        const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
        next.wT_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wT_12_FT;
      }
    }

    // F. If Weight/12 FT changed manually
    if ("wT_12_FT" in updates) {
      const wt12Ft = parseFloat(updates.wT_12_FT || 0);
      if (wt12Ft > 0 && cutLen > 0 && conv12Ft > 0) {
        const perPiece = (wt12Ft * cutLen) / conv12Ft;
        next.wT_Per_Pcs = String(parseFloat(perPiece.toFixed(3)));
        if (pcs > 0) {
          next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
        }
      }
    }

    return next;
  };

  const handleManualStickerRowChange = (index, updates) => {
    setManualStickerRows((prev) => {
      const updated = [...prev];
      updated[index] = calculateManualStickerRowValues(updated[index], updates, dieOptions, unitOptions);
      return updated;
    });
  };

  const handleAddManualStickerRow = (index) => {
    setManualStickerRows((prev) => {
      const updated = [...prev];
      const defaultUnit = unitOptions?.[0];
      const newRow = createInitialManualStickerRow(defaultUnit?.value || "", defaultUnit?.label || "");
      if (typeof index === "number") {
        updated.splice(index + 1, 0, newRow);
      } else {
        updated.push(newRow);
      }
      return updated;
    });
  };

  const handleDeleteManualStickerRow = (index) => {
    setManualStickerRows((prev) => {
      if (prev.length <= 1) {
        const defaultUnit = unitOptions?.[0];
        return [createInitialManualStickerRow(defaultUnit?.value || "", defaultUnit?.label || "")];
      }
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleSetAllManualStickerBranding = (withBranding) => {
    setManualStickerRows((prev) =>
      prev.map((row) => ({ ...row, withBranding }))
    );
  };

  const handleOpenManualStickerModal = () => {
    if (unitOptions.length > 0) {
      setManualStickerRows((prev) =>
        prev.map((r) =>
          !r.unit_Conv_Id
            ? { ...r, unit_Conv_Id: unitOptions[0]?.value, unit_Conv_Name: unitOptions[0]?.label }
            : r
        )
      );
    }
    setIsManualStickerModalOpen(true);
  };

  const handleManualStickerSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!manualStickerRows || manualStickerRows.length === 0) {
      notify("Please add at least one bundle row", "warning");
      return;
    }

    for (let i = 0; i < manualStickerRows.length; i++) {
      const row = manualStickerRows[i];
      if (!String(row.bundle_No || "").trim()) {
        notify(`Please enter Bundle No. in row ${i + 1}`, "warning");
        return;
      }
    }

    setLoading(true);
    try {
      const hasAnyBranding = manualStickerRows.some((row) => row.withBranding !== false);

      const payload = {
        bundles: manualStickerRows.map((row) => {
          const selectedDie = dieOptions.find((d) => String(d.value) === String(row.die_Id));
          const selectedUnit = unitOptions.find((u) => String(u.value) === String(row.unit_Conv_Id));

          return {
            bundle_No: String(row.bundle_No || "").trim(),
            die_Id: Number(row.die_Id || 0),
            die_No: String(row.die_No || selectedDie?.label || selectedDie?.dieNumber || ""),
            profile_Name: String(row.profile_Name || selectedDie?.profileName || ""),
            total_Pcs: Number(row.total_Pcs || 0),
            total_Weight: parseFloat(row.total_Weight || 0),
            cut_Length: parseFloat(row.cut_Length || 0),
            wT_Per_Pcs: parseFloat(row.wT_Per_Pcs || 0),
            wT_12_FT: parseFloat(row.wT_12_FT || 0),
            die_Image: String(row.die_Image || selectedDie?.dieImage || ""),
            unit_Conv_Name: String(row.unit_Conv_Name || selectedUnit?.label || ""),
            withBranding: row.withBranding !== false,
          };
        }),
      };

      const res = await packingEntryAPI.manualStickerPrint(payload, hasAnyBranding);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");

      notify("Manual stickers printed successfully", "success");
      setIsManualStickerModalOpen(false);
      const defaultUnit = unitOptions?.[0];
      setManualStickerRows([createInitialManualStickerRow(defaultUnit?.value || "", defaultUnit?.label || "")]);
    } catch (error) {
      let errMsg = "Failed to print manual sticker";
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errMsg = json?.message || errMsg;
        } catch {
          // ignore
        }
      } else if (error?.response?.data?.message) {
        errMsg = error.response.data.message;
      }
      notify(errMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleApplyFilters = () => {
    if (isActiveTab === "aging-done") {
      setAgingFilters(tempFilters);
    } else {
      setPackingFilters(tempFilters);
    }
  };

  const handleClearFilters = () => {
    setTempFilters({});
    if (isActiveTab === "aging-done") {
      setAgingFilters({});
    } else {
      setPackingFilters({});
    }
  };

  const openFilterDrawer = () => {
    const currentFilters = isActiveTab === "aging-done" ? agingFilters : packingFilters;
    setTempFilters(currentFilters);
    setIsFilterDrawerOpen(true);
  };

  const getFilterFields = () => {
    if (isActiveTab === "aging-done") {
      return [
        { name: "order_No", label: "Order No", type: "text", placeholder: "Enter Order No..." },
        { name: "batch_Id", label: "Batch No", type: "select", options: batchOptions },
        { name: "dieNumber", label: "Die No", type: "select", options: dieOptions },
        { name: "cut_Length", label: "Cut Length", type: "text", placeholder: "Enter Cut Length..." },
      ];
    } else {
      return [
        { name: "bundle_No", label: "Bundle No", type: "text", placeholder: "Enter Bundle No..." },
        { name: "dieNumber", label: "Die No", type: "select", options: dieOptions },
        { name: "series_Name", label: "Series", type: "select", options: seriesOptions },
        { name: "profile_Name", label: "Profile", type: "text", placeholder: "Enter Profile..." },
      ];
    }
  };

  const renderActiveFilterBadges = () => {
    const currentFilters = isActiveTab === "aging-done" ? agingFilters : packingFilters;
    const activeKeys = Object.keys(currentFilters).filter((k) => currentFilters[k]);

    if (activeKeys.length === 0) return null;

    const getFieldLabel = (key) => {
      const labels = {
        order_No: "Order No",
        batch_Id: "Batch No",
        dieNumber: "Die No",
        cut_Length: "Cut Length",
        bundle_No: "Bundle No",
        series_Name: "Series",
        profile_Name: "Profile",
      };
      return labels[key] || key;
    };

    const getDisplayValue = (key, val) => {
      if (key === "dieNumber") {
        const option = dieOptions.find((d) => String(d.value) === String(val));
        return option ? option.label : val;
      }
      return val;
    };

    const removeFilterKey = (key) => {
      if (isActiveTab === "aging-done") {
        setAgingFilters((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      } else {
        setPackingFilters((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      }
    };

    return (
      <div className="flex flex-wrap items-center gap-2 py-2 px-1 mb-2 bg-gray-50/50 border-b border-gray-100 rounded-sm">
        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
          Active Filters:
        </span>
        {activeKeys.map((key) => (
          <div
            key={key}
            className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 border border-blue-100 text-primary rounded-sm text-[10px] font-medium animate-fadeIn"
          >
            <span>{getFieldLabel(key)}:</span>
            <span className="font-bold">{getDisplayValue(key, currentFilters[key])}</span>
            <button
              onClick={() => removeFilterKey(key)}
              className="text-primary hover:text-red-500 transition-colors ml-1 font-bold text-[11px]"
            >
              ×
            </button>
          </div>
        ))}
        <button
          onClick={handleClearFilters}
          className="text-[10px] font-black uppercase tracking-wider text-red-500 hover:text-red-700 transition-colors ml-auto px-2 py-1"
        >
          Clear All
        </button>
      </div>
    );
  };

  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        const batchRes = await aging.getAllAgingBatch();
        if (batchRes) {
          const batches = Array.isArray(batchRes) ? batchRes : batchRes.data || [];
          setBatchOptions(
            batches.map((b) => {
              const val = typeof b === "string" ? b : b.batch_Id || b.Batch_Id;
              return { value: val, label: val };
            })
          );
        }

        const dieRes = await dieMasterAPI.getAll();
        if (dieRes) {
          const dies = Array.isArray(dieRes) ? dieRes : dieRes.data || [];
          setDieOptions(
            dies.map((d) => {
              const dieNo = d.dieNumber || d.DieNumber || d.die_No || d.Die_No || d.dieNo || d.DieNo || "";
              const subDieNo = d.subDieNo || d.SubDieNo || d.sub_Die_No || d.Sub_Die_No || d.subDie || d.SubDie || "";
              const label = subDieNo ? `${dieNo} / ${subDieNo}` : dieNo;
              const profileName = d.profileName || d.ProfileName || d.profile_Name || d.Profile_Name || d.profile || d.Profile || "";
              const currentWeightPer12Ft = parseFloat(d.currentWeightPer12Ft || d.CurrentWeightPer12Ft || d.wt_12_FT || d.wT_12_FT || 0);
              const currentWeight = parseFloat(d.currentWeight || d.CurrentWeight || d.weight || 0);
              const dieWt12Ft = currentWeightPer12Ft > 0 ? currentWeightPer12Ft : (currentWeight > 0 ? currentWeight : 0);
              return {
                value: d.id || d.Id,
                label: label,
                dieNumber: dieNo,
                subDieNo: subDieNo,
                profileName: profileName,
                wt12Ft: dieWt12Ft > 0 ? dieWt12Ft : "",
                dieImage: d.die_Image || d.dieImage || d.DieImage || d.image || d.Die_Image || "",
              };
            })
          );
        }

        const unitRes = await unitConversionAPI.getAll();
        if (unitRes) {
          const units = Array.isArray(unitRes) ? unitRes : unitRes.data || [];
          const unitOpts = units.map((u) => ({
            value: u.unit_Conv_Id || u.id,
            label: u.unit_Conv_Name || u.name,
            raw: parseFloat(u.conv_Value || u.conv_value || u.Conv_Value || u.convValue || 1),
          }));
          setUnitOptions(unitOpts);
          if (unitOpts.length > 0) {
            setManualStickerRows((prev) =>
              prev.map((r) =>
                !r.unit_Conv_Id
                  ? { ...r, unit_Conv_Id: unitOpts[0].value, unit_Conv_Name: unitOpts[0].label }
                  : r
              )
            );
          }
        }
      } catch (err) {
        console.error("Failed to load filter options", err);
      }
    };
    loadFilterOptions();
  }, []);

  const [formData, setFormData] = useState({
    packing_Date: today,
    packingDetails: [{
      bundle_No: "0",
      order_No: "",
      dieNumber: "",
      die_Id: "",
      batch_Id: "",
      casting_No: "",
      cut_Length: "",
      wt_12_FT: "",
      wt_Cut_Length: "",
      pcs: "",
      total_Weight: "",
      series_Name: "",
      remark: "",
      unit_Conv_Id: "",
      final_CutLength_weight: "",
      seq_No: "",
    }]
  });
  const pageSize = 50;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState(null);
  const [adding, setAdding] = useState(false);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [savedBundles, setSavedBundles] = useState([]);
  const [isPrintStickerModalOpen, setIsPrintStickerModalOpen] = useState(false);
  const [printStickerBranding, setPrintStickerBranding] = useState(true);
  const [savedBundlesBranding, setSavedBundlesBranding] = useState(true);
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [packingHasMore, setPackingHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [packingPage, setPackingPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);
  const [isPackingListModalOpen, setIsPackingListModalOpen] = useState(false);
  const [soldOutData, setSoldOutData] = useState([]);
  const [soldOutPage, setSoldOutPage] = useState(1);
  const [soldOutHasMore, setSoldOutHasMore] = useState(true);
  const [scannedBundles, setScannedBundles] = useState([]);
  const [vehicleNo, setVehicleNo] = useState("");
  const [currentBarcode, setCurrentBarcode] = useState("");
  const [isBranding, setIsBranding] = useState(true);
  const [isDispatchModalOpen, setIsDispatchModalOpen] = useState(false);
  const [selectedDispatchNo, setSelectedDispatchNo] = useState("");
  const [dispatchBranding, setDispatchBranding] = useState(true);
  const barcodeInputRef = useRef(null);
  const [isDispatchAdditionModalOpen, setIsDispatchAdditionModalOpen] = useState(false);
  const [dispatchAdditionNo, setDispatchAdditionNo] = useState("");
  const [dispatchAdditionBarcode, setDispatchAdditionBarcode] = useState("");
  const [dispatchAdditionBundles, setDispatchAdditionBundles] = useState([]);
  const [dispatchAdditionSaving, setDispatchAdditionSaving] = useState(false);
  const dispatchAdditionInputRef = useRef(null);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_packing_tour_seen", "true");
  };

  const fetchPackingData = async (page = 1, currentFilters = packingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(page, pageSize, currentFilters);
      setisPackingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setPackingHasMore(false);
      } else {
        setPackingHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  const fetchSoldOutData = async (page = 1, currentFilters = packingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllSoldOutEntry(page, pageSize, currentFilters);
      setSoldOutData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setSoldOutHasMore(false);
      } else {
        setSoldOutHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sold out data", "error");
    }
    setLoading(false);
  };

  const submitImport = async (e) => {
    e.preventDefault();
    if (!importFile) {
      notify("Please select a file to import", "warning");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", importFile);
    formData.append("userId", userId);

    try {
      await aging.agingDoneImport(formData);
      notify("Imported successfully", "success");
      setIsImportModalOpen(false);
      setImportFile(null);
      if (isActiveTab === "aging-done") fetchAgingDoneData();
    } catch (error) {
      notify(error?.response?.data?.message || "Failed to import file", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setLoading(true);
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setSelectedPackingData({
        packing_Date: doc.packing_Date || today,
        totalPcs: doc.totalPcs ?? 0,
        total_Weight: doc.total_Weight ?? 0,
        packingDetails: [doc]
      });
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    setIsSaving(true);
    try {
      if (!data.packingDetails || data.packingDetails.length === 0) {
        notify("Please add at least one row.", "warning");
        setIsSaving(false);
        return;
      }

      // Sum of pcs and total weight from row details
      const sumPcs = data.packingDetails.reduce((sum, row) => sum + Number(row.pcs || 0), 0);
      // const sumWeight = data.packingDetails.reduce((sum, row) => sum + parseFloat(row.total_Weight || 0), 0);

      const totalPcsAllowed = Number(data.totalPcs || 0);

      if (totalPcsAllowed > 0 && sumPcs > totalPcsAllowed) {
        notify(`Sum of Pcs (${sumPcs}) cannot exceed Total Pcs (${totalPcsAllowed})`, "error");
        setIsSaving(false);
        return;
      }

      // if (totalWeightAllowed > 0 ) {
      //   notify(`Sum of Total Weight (${sumWeight.toFixed(2)} KG) cannot exceed Total Weight (${totalWeightAllowed.toFixed(2)} KG)`, "error");
      //   setIsSaving(false);
      //   return;
      // }

      const payload = data.packingDetails.map((row) => ({
        bundle_No: String(row.bundle_No || "0"),
        packing_Date: data.packing_Date,
        order_No: Number(row.order_No || 0),
        die_Id: Number(row.die_Id || 0),
        cut_Length: parseFloat(row.cut_Length || 0),
        wT_12_FT: parseFloat(row.wt_12_FT || row.wT_12_FT || 0),
        wT_Cut_Length: parseFloat(row.wt_Cut_Length || row.wT_Cut_Length || 0),
        pcs: Number(row.pcs || 0),
        total_Weight: parseFloat(row.total_Weight || 0),
        series_Name: String(row.series_Name || ""),
        remark: String(row.remark || ""),
        created_By: Number(userId || 0),
        batch_Id: String(row.batch_Id || ""),
        casting_No: String(row.casting_No || ""),
        unit_Conv_Id: Number(row.unit_Conv_Id || 0),
        final_CutLength_weight: parseFloat(row.final_CutLength_weight || 0),
        seq_No: Number(row.seq_No || 0),
      }));

      const response = await packingEntryAPI.saveOrUpdateMultiple(payload);
      notify("Saved successfully", "success");

      const resultsArray = response?.results || (Array.isArray(response) ? response : []);
      const bundleNos = resultsArray.map((r) => r.bundle_No).filter(Boolean);

      setIsActiveTab("packing");
      setPackingPage(1);
      setAgingPage(1);
      fetchPackingData(1);
      fetchAgingDoneData(1);
      setIsModelOpen(false);
      setFormData({
        packing_Date: today,
        totalPcs: 0,
        total_Weight: 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: "",
          dieNumber: "",
          die_Id: "",
          batch_Id: "",
          casting_No: "",
          cut_Length: "",
          wt_12_FT: "",
          wt_Cut_Length: "",
          pcs: "",
          total_Weight: "",
          series_Name: "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: "",
        }]
      });
      setIsEditing(false);

      if (bundleNos.length > 0) {
        setSavedBundles(bundleNos);
        setPrintModalOpen(true);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fetchAgingDoneData = async (page = 1, currentFilters = agingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(page, pageSize, currentFilters);
      setIsAgingDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      } else {
        setAgingHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    setAgingFilters({});
    setPackingFilters({});
    if (tab === "aging-done") {
      setPackingPage(1);
      setIsAgingDoneData([]);
      setAgingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "packing") {
      setPackingPage(1);
      setisPackingData([]);
      setPackingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "sold-out") {
      setSoldOutPage(1);
      setSoldOutData([]);
      setSoldOutHasMore(true);
      setPackingPage(1);
      setAgingPage(1);
    }
  };

  useEffect(() => {
    if (isActiveTab === "aging-done") fetchAgingDoneData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "aging-done") {
      if (agingPage === 1) {
        fetchAgingDoneData(1, agingFilters);
      } else {
        setAgingPage(1);
      }
    }
  }, [agingFilters]);

  useEffect(() => {
    if (isActiveTab === "packing") fetchPackingData(packingPage);
  }, [packingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "packing") {
      if (packingPage === 1) {
        fetchPackingData(1, packingFilters);
      } else {
        setPackingPage(1);
      }
    }
  }, [packingFilters]);

  useEffect(() => {
    if (isActiveTab === "sold-out") fetchSoldOutData(soldOutPage);
  }, [soldOutPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "sold-out") {
      if (soldOutPage === 1) {
        fetchSoldOutData(1, packingFilters);
      } else {
        setSoldOutPage(1);
      }
    }
  }, [packingFilters]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "aging-done" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }

        if (isActiveTab === "packing" && packingHasMore) {
          setPackingPage((p) => p + 1);
        }

        if (isActiveTab === "sold-out" && soldOutHasMore) {
          setSoldOutPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, packingHasMore, agingHasMore, soldOutHasMore]);

  const columns = [
    {
      key: "select",
      align: "center",
      disableSort: true,
      label: <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Select</span>,
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = selectedAgingNo === id;
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => setSelectedAgingNo(isChecked ? null : id)}
            className="w-4 h-4 text-primary cursor-pointer accent-primary"
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO", align: "center" },
    {
      key: "batch_Id",
      label: "BATCH NO",
      align: "center",
      filterType: "select",
      filterOptions: batchOptions,
    },
    {
      key: "dieNumber",
      label: "DIE NO",
      align: "center",
      filterType: "select",
      filterOptions: dieOptions,
      render: (val, row) => {
        const pdfUrl = getDiePdfUrl(row);
        return pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-black hover:underline cursor-pointer"
          >
            {val}
          </a>
        ) : (
          <span>{val}</span>
        );
      }
    },
    { key: "cut_Length", label: "CUT LENGTH", align: "center" },
    { key: "quantity", label: "PCS", align: "center", disableFilter: true },
    { key: "pending_Pcs", label: "PENDING PCS", align: "center", disableFilter: true },
    { key: "total_Weight", label: "TOTAL WEIGHT", align: "center", disableFilter: true },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(selectedAgingNo);
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        packing_Date: x.packing_Date,
        totalPcs: x?.totalPcs ?? 0,
        total_Weight: x?.total_Weight ?? 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: x?.order_No ?? "",
          die_Id: x?.die_Id ?? null,
          dieNumber: x?.dieNumber ?? "",
          cut_Length: x?.cut_Length ?? "",
          batch_Id: x?.batch_Id ?? "",
          casting_No: x?.casting_No ?? "",
          total_Weight: x?.total_Weight ?? "",
          wt_12_FT: "",
          wt_Cut_Length: x?.cut_Length ?? "",
          pcs: "",
          series_Name: x?.series_Name ?? "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: x?.seq_No ?? selectedAgingNo ?? 0,
        }]
      };
      setSelectedPackingData(init);
      setIsModelOpen(true);
      setIsEditing(false);
      setSelectedAgingNo(null);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const handlePrint = () => {
    if (selectedBundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }
    setPrintStickerBranding(true);
    setIsPrintStickerModalOpen(true);
  };

  const executePrintBundles = async (bundles, withBranding = true) => {
    if (!bundles || bundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        withBranding: Boolean(withBranding),
        bundleNos: bundles,
      };
      const res = await packingEntryAPI.packingBundles(payload);

      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");

      setIsPrintStickerModalOpen(false);
      setPrintModalOpen(false);
    } catch (error) {
      notify("Failed to print selected bundles", "error");
    } finally {
      setLoading(false);
    }
  };

  const currentDataForSeries = isActiveTab === "sold-out" ? soldOutData : isPackingData;
  const seriesOptions = Array.from(
    new Set(currentDataForSeries.map((x) => x.series_Name || x.Series_Name).filter(Boolean))
  ).map((s) => ({ value: s, label: s }));

  const existingDispatchOptions = Array.from(
    new Set(soldOutData.map((x) => x.dispatch_No).filter(Boolean))
  ).map((d) => ({ value: d, label: d }));

  const handleOpenDispatchAddition = (dispatchNo = "") => {
    setDispatchAdditionNo(dispatchNo || "");
    setDispatchAdditionBarcode("");
    setDispatchAdditionBundles([]);
    setIsDispatchAdditionModalOpen(true);
  };

  const handleAddDispatchAdditionBundle = () => {
    const code = dispatchAdditionBarcode.trim();
    if (!code) return;

    setDispatchAdditionBundles((prev) => [...prev, code]);
    setDispatchAdditionBarcode("");
    if (dispatchAdditionInputRef.current) {
      dispatchAdditionInputRef.current.focus();
    }
  };

  const handleSaveDispatchAddition = async () => {
    if (!dispatchAdditionNo?.trim()) {
      notify("Please select or enter a Dispatch No", "warning");
      return;
    }
    if (dispatchAdditionBundles.length === 0) {
      notify("Please scan or enter at least one bundle", "warning");
      return;
    }

    setDispatchAdditionSaving(true);
    try {
      const payload = {
        dispatchNo: dispatchAdditionNo.trim(),
        bundleNos: dispatchAdditionBundles,
      };
      const res = await packingEntryAPI.dispatchAddition(payload);
      notify(res?.message || "Bundles added to dispatch successfully", "success");
      setIsDispatchAdditionModalOpen(false);
      setDispatchAdditionBundles([]);
      setDispatchAdditionNo("");
      setDispatchAdditionBarcode("");

      // Refresh Sold Out data and Packing data
      fetchSoldOutData(1);
      if (isActiveTab === "packing") {
        fetchPackingData(1);
      }
    } catch (error) {
      notify(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to add bundles to dispatch",
        "error"
      );
    } finally {
      setDispatchAdditionSaving(false);
    }
  };

  useEffect(() => {
    if (isDispatchAdditionModalOpen) {
      const timer = setTimeout(() => {
        if (dispatchAdditionInputRef.current) {
          dispatchAdditionInputRef.current.focus();
        }
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [isDispatchAdditionModalOpen]);

  const handleDispatchClick = (dispatchNo) => {
    if (!dispatchNo) return;
    setSelectedDispatchNo(dispatchNo);
    setDispatchBranding(true);
    setIsDispatchModalOpen(true);
  };

  const executeGeneratePackingListByDispatchNo = async (dispatchNo, withBranding = true) => {
    if (!dispatchNo) return;
    setLoading(true);
    try {
      const res = await packingEntryAPI.generatePackingListByDispatchNo(dispatchNo, withBranding);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
      setIsDispatchModalOpen(false);
    } catch (error) {
      let errMsg = "Failed to generate packing list for this Dispatch No.";
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errMsg = json?.message || errMsg;
        } catch {
          // ignore
        }
      } else if (error?.response?.data?.message) {
        errMsg = error.response.data.message;
      }
      notify(errMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}

      <RegistryHeader title="Packing Plan View">
        <button
          onClick={() => setIsTourOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Start Onboarding Tour"
        >
          <Info size={14} className="shrink-0" />
          Guide
        </button>
        <button
          onClick={handleOpenManualStickerModal}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Manual Sticker Print"
        >
          <MdPrint size={14} className="shrink-0" />
          Manual Sticker Print
        </button>
        <button
          onClick={() => setIsImportModalOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Import Data"
        >
          <Upload size={14} className="shrink-0" />
          Import
        </button>
        <button
          onClick={openFilterDrawer}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Open Filter Drawer"
        >
          <FilterIcon size={14} className="shrink-0" />
          Filter
        </button>
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0" data-tour="packing-tabs">
          <button
            onClick={() => handleTabChange("aging-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging-done"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
          <button
            onClick={() => handleTabChange("packing")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "packing"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Packing Entry
          </button>
          <button
            onClick={() => handleTabChange("sold-out")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "sold-out"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Sold Out
          </button>
        </div>
        {isActiveTab === "aging-done" ? (
          <Button
            disabled={adding}
            onClick={handleAddPacking}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={adding}
            data-tour="add-packing-btn"
          >
            {adding ? "INITIALIZING..." : `ADD Packing`}
          </Button>
        ) : isActiveTab === "packing" ? (
          <div className="flex gap-2">
            <button
              onClick={() => setIsPackingListModalOpen(true)}
              className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            >
              Packing List
            </button>
            <Button
              onClick={handlePrint}
              disabled={selectedBundles.length === 0 || loading}
              icon={MdPrint}
              className="whitespace-nowrap"
              loading={adding}
              data-tour="print-sticker-btn"
            >
              {adding ? "INITIALIZING..." : `Print Sticker (${selectedBundles.length})`}
            </Button>
          </div>
        ) : isActiveTab === "sold-out" ? (
          <div className="flex gap-2">
            <Button
              onClick={() => handleOpenDispatchAddition()}
              icon={HiOutlinePlus}
              className="whitespace-nowrap"
            >
              Add Bundles
            </Button>
          </div>
        ) : null}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        {renderActiveFilterBadges()}
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
          data-tour="packing-table"
        >
          {isActiveTab === "aging-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isAgingDoneData}
                showActions={false}
                onRowClick={(row) => {
                  const id = Number(row.seq_No);
                  setSelectedAgingNo((prev) => (prev === id ? null : id));
                }} tableClassName="text-[13px]"
              />
            </div>
          )}
          {isActiveTab === "packing" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "select",
                    disableSort: true,
                    disableFilter: true,
                    align: "center",
                    className: "w-12 border-r border-gray-100",
                    label: (
                      <input
                        type="checkbox"
                        checked={
                          isPackingData.length > 0 &&
                          isPackingData.every((row) => selectedBundles.includes(row.bundle_No))
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            const allIds = isPackingData.map((row) => row.bundle_No);
                            setSelectedBundles(allIds);
                          } else {
                            setSelectedBundles([]);
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    ),
                    render: (val, row) => (
                      <input
                        type="checkbox"
                        checked={selectedBundles.includes(row.bundle_No)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedBundles((prev) => [...prev, row.bundle_No]);
                          } else {
                            setSelectedBundles((prev) => prev.filter((id) => id !== row.bundle_No));
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    )
                  },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    filterType: "select",
                    filterOptions: dieOptions,
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  {
                    key: "series_Name",
                    label: "SERIES",
                    align: "left",
                    filterType: "select",
                    filterOptions: seriesOptions,
                    className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider"
                  },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", disableFilter: true, className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  },
                  {
                    key: "actions",
                    label: "ACTIONS",
                    align: "center",
                    disableFilter: true,
                    render: (val, row) => (
                      <button
                        onClick={() => handleEdit(row)}
                        className="px-2.5 py-1 border border-gray-200 text-blue-600 hover:bg-blue-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none"
                      >
                        Edit
                      </button>
                    )
                  }
                ]}
                data={isPackingData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
          {isActiveTab === "sold-out" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "dispatch_No",
                    label: "DISPATCH NO",
                    align: "center",
                    className: "font-black text-gray-900 border-r border-gray-100",
                    render: (val) => {
                      return val ? (
                        <span
                          onClick={() => handleDispatchClick(val)}
                          className="text-primary hover:underline cursor-pointer"
                          title="Click to generate packing list"
                        >
                          {val}
                        </span>
                      ) : (
                        <span>-</span>
                      );
                    }
                  },
                  { key: "dispatch_Date", label: "DISPATCH DATE", align: "center", },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    filterType: "select",
                    filterOptions: dieOptions,
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  {
                    key: "series_Name",
                    label: "SERIES",
                    align: "left",
                    filterType: "select",
                    filterOptions: seriesOptions,
                    className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider"
                  },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", disableFilter: true, className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  },
                  {
                    key: "actions",
                    label: "ACTIONS",
                    align: "center",
                    disableFilter: true,
                    render: (val, row) => (
                      <button
                        onClick={() => handleOpenDispatchAddition(row.dispatch_No)}
                        className="px-2.5 py-1 border border-primary text-primary hover:bg-primary hover:text-white transition-all text-[10px] font-black uppercase tracking-wider rounded-none flex items-center gap-1 mx-auto"
                        title={`Add bundles to dispatch ${row.dispatch_No}`}
                      >
                        <HiOutlinePlus size={12} />
                        Add Bundle
                      </button>
                    )
                  }
                ]}
                data={soldOutData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          formData={formData}
          setFormData={setFormData}
          isSaving={isSaving}
        />
      )}

      <Model
        isOpen={isImportModalOpen}
        onClose={() => {
          setIsImportModalOpen(false);
          setImportFile(null);
        }}
        name="Import Aging Done"
        widthClass="max-w-md"
      >
        <form onSubmit={submitImport} className="flex flex-col p-6 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
              Select File <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              required
              onChange={(e) => setImportFile(e.target.files?.[0] || null)}
              className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
            />
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsImportModalOpen(false);
                setImportFile(null);
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50"
            >
              {loading ? "Importing..." : "Submit"}
            </button>
          </div>
        </form>
      </Model>
      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <Model
        isOpen={isPackingListModalOpen}
        onClose={() => {
          setIsPackingListModalOpen(false);
          setScannedBundles([]);
          setVehicleNo("");
          setCurrentBarcode("");
        }}
        name="Generate Packing List"
        widthClass="max-w-2xl"
        closeOnOutsideClick={false}
      >
        <div className="flex flex-col p-6 gap-4">
          <div className="flex gap-4">
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Scan Barcode
              </label>
              <input
                ref={barcodeInputRef}
                type="text"
                value={currentBarcode}
                onChange={(e) => setCurrentBarcode(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter' && currentBarcode.trim()) {
                    e.preventDefault();
                    const scannedCode = currentBarcode.trim();

                    if (scannedBundles.includes(scannedCode)) {
                      notify("Bundle already scanned", "warning");
                      setCurrentBarcode("");
                      return;
                    }

                    try {
                      const res = await packingEntryAPI.validateBundleNo(scannedCode);
                      if (res === "Valid" || res?.message === "Valid" || res?.status === "Valid") {
                        setScannedBundles(prev => [...prev, scannedCode]);
                      } else {
                        notify(res?.message || res || "Invalid Bundle No", "warning");
                      }
                    } catch (error) {
                      notify(error?.response?.data?.message || error?.message || "Failed to validate barcode", "warning");
                    }
                    setCurrentBarcode("");
                  }
                }}
                placeholder="Scan or enter bundle no and press Enter"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
                autoFocus
              />
            </div>
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Vehicle No <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                placeholder="Enter Vehicle No"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors uppercase"
              />
            </div>
          </div>

          <div className="flex items-center gap-2 pt-1 pb-0.5">
            <label className="flex items-center gap-2 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={isBranding}
                onChange={(e) => setIsBranding(e.target.checked)}
                className="w-4 h-4 text-primary accent-primary cursor-pointer border-gray-300"
              />
              <span className="text-[12px] font-black uppercase tracking-wider text-slate-700">
                Is Branding
              </span>
            </label>
          </div>

          <div className="mt-2 border border-gray-200 rounded-sm overflow-hidden flex flex-col" style={{ minHeight: '200px' }}>
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 text-[11px] font-black text-gray-600 uppercase tracking-wider flex justify-between">
              <span>Scanned Bundles ({scannedBundles.length})</span>
              {scannedBundles.length > 0 && (
                <button onClick={() => setScannedBundles([])} className="text-red-500 hover:text-red-700 font-bold text-[10px]">Clear All</button>
              )}
            </div>
            <div className="flex-1 overflow-y-auto p-4 bg-slate-50 flex flex-wrap gap-2 items-start content-start">
              {scannedBundles.map((b, idx) => (
                <div key={idx} className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 text-primary font-mono text-[13px] font-black tracking-tight group">
                  {b}
                  <MdClose
                    className="cursor-pointer text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                    onClick={() => setScannedBundles(prev => prev.filter(item => item !== b))}
                  />
                </div>
              ))}
              {scannedBundles.length === 0 && (
                <div className="text-gray-400 text-sm w-full text-center py-8">No bundles scanned yet</div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsPackingListModalOpen(false);
                setScannedBundles([]);
                setVehicleNo("");
                setCurrentBarcode("");
                setIsBranding(true);
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading || scannedBundles.length === 0 || !vehicleNo.trim()}
              onClick={async () => {
                setLoading(true);
                try {
                  const payload = {
                    bundleNos: scannedBundles,
                    vehicleNo: vehicleNo.trim(),
                    isBranding: Boolean(isBranding),
                    withBranding: Boolean(isBranding),
                  };
                  const res = await packingEntryAPI.generatePackingList(payload);

                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const pdfUrl = URL.createObjectURL(blob);
                  window.open(pdfUrl, "_blank");

                  notify("Packing list generated successfully", "success");
                  setIsPackingListModalOpen(false);
                  setScannedBundles([]);
                  setVehicleNo("");
                  setCurrentBarcode("");
                  setIsBranding(true);
                  fetchPackingData()
                } catch (error) {
                  notify(error?.response?.data?.message || "Failed to generate packing list", "error");
                } finally {
                  setLoading(false);
                }
              }}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex gap-2 items-center"
            >
              {loading ? "Generating..." : "Save & Generate"}
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={isPrintStickerModalOpen}
        onClose={() => setIsPrintStickerModalOpen(false)}
        name="Print Sticker"
        widthClass="max-w-md"
      >
        <div className="flex flex-col p-6 gap-5">
          <div className="flex flex-col gap-2">
            <span className="text-[11px] font-black text-slate-500 uppercase tracking-wider">
              Selected Bundles ({selectedBundles.length})
            </span>
            <div className="flex flex-wrap gap-1.5 max-h-32 overflow-y-auto bg-slate-50 p-3 border border-slate-200">
              {selectedBundles.map((b, idx) => (
                <span
                  key={idx}
                  className="px-2.5 py-1 bg-white border border-gray-200 text-primary font-mono text-[11px] font-black tracking-tight"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[11px] font-black uppercase tracking-wider text-slate-700">
              Select Branding Option
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={() => setPrintStickerBranding(true)}
                className={`flex flex-col items-center justify-center p-3 border transition-all ${printStickerBranding === true
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  }`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">With Branding</span>
                <span className="text-[9px] text-gray-400 mt-0.5">With Brand & Logo</span>
              </button>
              <button
                type="button"
                onClick={() => setPrintStickerBranding(false)}
                className={`flex flex-col items-center justify-center p-3 border transition-all ${printStickerBranding === false
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  }`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">Without Branding</span>
                <span className="text-[9px] text-gray-400 mt-0.5">Plain Sticker</span>
              </button>
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-2 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => setIsPrintStickerModalOpen(false)}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading}
              onClick={() => executePrintBundles(selectedBundles, printStickerBranding)}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex items-center gap-2"
            >
              <MdPrint size={14} />
              {loading ? "Generating..." : "Print Sticker"}
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={isDispatchModalOpen}
        onClose={() => {
          if (!loading) setIsDispatchModalOpen(false);
        }}
        name="Generate Packing List"
        widthClass="max-w-md"
        closeOnOutsideClick={!loading}
      >
        <div className="flex flex-col p-6 gap-5">
          <div className="flex flex-col gap-1 text-center">
            <span className="text-[11px] font-black text-slate-500 uppercase tracking-wider">
              Dispatch No: <span className="text-primary font-mono text-[14px] font-bold">{selectedDispatchNo}</span>
            </span>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[11px] font-black uppercase tracking-wider text-slate-700 text-center">
              Select Branding Option
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                disabled={loading}
                onClick={() => setDispatchBranding(true)}
                className={`flex flex-col items-center justify-center p-3 border transition-all ${dispatchBranding === true
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">With Branding</span>
                <span className="text-[9px] text-gray-400 mt-0.5">With Brand & Logo</span>
              </button>
              <button
                type="button"
                disabled={loading}
                onClick={() => setDispatchBranding(false)}
                className={`flex flex-col items-center justify-center p-3 border transition-all ${dispatchBranding === false
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">Without Branding</span>
                <span className="text-[9px] text-gray-400 mt-0.5">Plain Packing List</span>
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center mt-2 pt-4 border-t border-slate-100">
            <button
              type="button"
              disabled={loading}
              onClick={() => {
                setIsDispatchModalOpen(false);
                handleOpenDispatchAddition(selectedDispatchNo);
              }}
              className="px-3 py-2 border border-primary text-primary hover:bg-primary/5 text-[10px] font-black uppercase tracking-widest transition-colors flex items-center gap-1.5"
            >
              <HiOutlinePlus size={14} />
              Add Bundles
            </button>
            <div className="flex gap-2">
              <button
                type="button"
                disabled={loading}
                onClick={() => setIsDispatchModalOpen(false)}
                className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={loading}
                onClick={() => executeGeneratePackingListByDispatchNo(selectedDispatchNo, dispatchBranding)}
                className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex items-center gap-2"
              >
                <MdPrint size={14} />
                {loading ? "Generating..." : "Generate PDF"}
              </button>
            </div>
          </div>
        </div>
      </Model>

      <Model
        isOpen={isDispatchAdditionModalOpen}
        onClose={() => {
          if (!dispatchAdditionSaving) {
            setIsDispatchAdditionModalOpen(false);
            setDispatchAdditionBundles([]);
            setDispatchAdditionNo("");
            setDispatchAdditionBarcode("");
          }
        }}
        name="Add Bundles to Dispatch"
        widthClass="max-w-2xl"
        closeOnOutsideClick={!dispatchAdditionSaving}
      >
        <div className="flex flex-col p-6 gap-4 font-plus">
          {/* Dispatch Selection */}
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-bold text-gray-700 uppercase tracking-wider flex items-center justify-between">
              <span>
                Dispatch No <span className="text-red-500">*</span>
              </span>
            </label>
            <CreatableSelect
              options={existingDispatchOptions}
              value={
                dispatchAdditionNo
                  ? { value: dispatchAdditionNo, label: dispatchAdditionNo }
                  : null
              }
              onChange={(selected) => setDispatchAdditionNo(selected?.value || "")}
              onCreateOption={(newVal) => setDispatchAdditionNo(newVal.trim().toUpperCase())}
              placeholder="Select existing dispatch or type dispatch no..."
              isClearable
              formatCreateLabel={(inputValue) => `Use "${inputValue}"`}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: "38px",
                  fontSize: "13px",
                  borderRadius: "0",
                  borderColor: state.isFocused ? "#0F3D75" : "#e2e8f0",
                  backgroundColor: "#ffffff",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#0F3D75",
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "0 8px",
                }),
              }}
            />
          </div>

          {/* Barcode scanner input */}
          <div className="flex flex-col gap-1.5 pt-2 border-t border-gray-100">
            <label className="text-[11px] font-bold text-gray-700 uppercase tracking-wider flex items-center gap-1.5">
              Scan Barcode / Bundle No <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-2">
              <input
                ref={dispatchAdditionInputRef}
                type="text"
                value={dispatchAdditionBarcode}
                onChange={(e) => setDispatchAdditionBarcode(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    await handleAddDispatchAdditionBundle();
                  }
                }}
                placeholder="Scan or enter bundle no and press Enter"
                className="flex-1 py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors font-mono"
              />
              <button
                type="button"
                onClick={handleAddDispatchAdditionBundle}
                disabled={!dispatchAdditionBarcode.trim()}
                className="px-4 py-2 bg-primary text-white text-[11px] font-black uppercase tracking-wider hover:bg-primary/95 transition-colors disabled:opacity-50 shrink-0 flex items-center gap-1.5"
              >
                <HiOutlinePlus size={14} />
                Add
              </button>
            </div>
          </div>

          {/* Scanned Bundles List */}
          <div
            className="mt-1 border border-gray-200 rounded-none overflow-hidden flex flex-col"
            style={{ minHeight: "200px" }}
          >
            <div className="bg-gray-50 px-4 py-2.5 border-b border-gray-200 text-[11px] font-black text-gray-600 uppercase tracking-wider flex justify-between items-center">
              <span className="flex items-center gap-2">
                Scanned Bundles ({dispatchAdditionBundles.length})
                {dispatchAdditionBundles.length > 0 && (
                  <span className="bg-primary/10 text-primary text-[10px] px-2 py-0.5 font-mono">
                    Ready to add
                  </span>
                )}
              </span>
              {dispatchAdditionBundles.length > 0 && (
                <button
                  type="button"
                  onClick={() => setDispatchAdditionBundles([])}
                  className="text-red-500 hover:text-red-700 font-bold text-[10px] uppercase tracking-wider transition-colors"
                >
                  Clear All
                </button>
              )}
            </div>

            <div className="flex-1 overflow-y-auto max-h-60 p-4 bg-slate-50 flex flex-wrap gap-2 items-start content-start">
              {dispatchAdditionBundles.map((bundleNo, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 shadow-sm text-primary font-mono text-[13px] font-black tracking-tight group hover:border-primary/40 transition-all"
                >
                  <span>{bundleNo}</span>
                  <button
                    type="button"
                    onClick={() =>
                      setDispatchAdditionBundles((prev) =>
                        prev.filter((item) => item !== bundleNo)
                      )
                    }
                    className="text-gray-400 hover:text-red-500 transition-colors p-0.5"
                    title="Remove bundle"
                  >
                    <MdClose size={14} />
                  </button>
                </div>
              ))}
              {dispatchAdditionBundles.length === 0 && (
                <div className="text-gray-400 text-sm w-full text-center py-10 flex flex-col items-center justify-center gap-1">
                  <span className="font-medium">No bundles scanned yet</span>
                  <span className="text-[11px] text-gray-400">
                    Scan bundle barcodes or enter them above to add them to the dispatch
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Modal Footer */}
          <div className="flex justify-end gap-2 mt-2 pt-4 border-t border-slate-100">
            <button
              type="button"
              disabled={dispatchAdditionSaving}
              onClick={() => {
                setIsDispatchAdditionModalOpen(false);
                setDispatchAdditionBundles([]);
                setDispatchAdditionNo("");
                setDispatchAdditionBarcode("");
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={
                dispatchAdditionSaving ||
                dispatchAdditionBundles.length === 0 ||
                !dispatchAdditionNo?.trim()
              }
              onClick={handleSaveDispatchAddition}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex items-center gap-2 shadow-sm"
            >
              <HiOutlinePlus size={14} />
              {dispatchAdditionSaving
                ? "Adding Bundles..."
                : `Add Bundles (${dispatchAdditionBundles.length})`}
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={printModalOpen}
        onClose={() => {
          if (!loading) setPrintModalOpen(false);
        }}
        name="Print Bundle"
        widthClass="max-w-md"
        closeOnOutsideClick={!loading}
      >
        <div className="flex flex-col p-6 gap-5">
          <div className="flex flex-col gap-2.5 text-center">
            <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mx-auto mb-2">
              <MdPrint size={24} />
            </div>
            <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider">
              Do you want to print the stickers?
            </h3>
            <div className="flex flex-wrap gap-1.5 justify-center max-h-36 overflow-y-auto bg-slate-50 p-3 border border-slate-100/80 rounded-none">
              {savedBundles.map((b, idx) => (
                <span
                  key={idx}
                  className="px-2.5 py-1 bg-white border border-gray-200 text-primary font-mono text-[11px] font-black tracking-tight"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[11px] font-black uppercase tracking-wider text-slate-700 text-center">
              Select Branding Option
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                disabled={loading}
                onClick={() => setSavedBundlesBranding(true)}
                className={`flex flex-col items-center justify-center p-2.5 border transition-all ${savedBundlesBranding === true
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">With Branding</span>
              </button>
              <button
                type="button"
                disabled={loading}
                onClick={() => setSavedBundlesBranding(false)}
                className={`flex flex-col items-center justify-center p-2.5 border transition-all ${savedBundlesBranding === false
                  ? "border-primary bg-primary/5 text-primary shadow-sm ring-1 ring-primary font-bold"
                  : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                  } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                <span className="text-[11px] font-black uppercase tracking-wider">Without Branding</span>
              </button>
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              disabled={loading}
              onClick={() => setPrintModalOpen(false)}
              className="px-5 py-2.5 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors rounded-none min-w-28 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              No
            </button>
            <button
              type="button"
              disabled={loading}
              onClick={() => executePrintBundles(savedBundles, savedBundlesBranding)}
              className="px-5 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors rounded-none min-w-28 shadow-sm flex items-center justify-center gap-2 disabled:opacity-75 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-3.5 w-3.5 text-white shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Printing...</span>
                </>
              ) : (
                "Yes"
              )}
            </button>
          </div>
        </div>
      </Model>

      <div data-tour="packing-footer">
        <CalculationFooter
          items={[
            isActiveTab === 'packing' && {
              label: "Selected Rows",
              value: isActiveTab === 'packing' ? selectedBundles.length : 0,
              suffix: "Rows",
              color: "text-green-500"
            },
            (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Units",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.pcs) || 0), 0)
                  .toLocaleString()
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.quantity) || 0), 0)
                  .toLocaleString(),
              suffix: "PCS",
              color: "text-primary"
            }, (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Weight",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3)
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }, {
              label: "Total Units",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.quantity) || 0), 0).toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "Total Weight",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3),
              suffix: "KG",
              color: "text-black"
            },


          ].filter(Boolean)}
        />
      </div>

      <Model
        isOpen={isManualStickerModalOpen}
        onClose={() => {
          setIsManualStickerModalOpen(false);
        }}
        name="Manual Sticker Print"
        widthClass="max-w-6xl"
        bodyClass="overflow-hidden flex flex-col"
      >
        <form onSubmit={handleManualStickerSubmit} className="flex flex-col h-full max-h-[85vh] overflow-hidden">
          {/* Top Bar: Stats & Controls */}
          <div className="p-3 px-5 border-b border-slate-100 bg-slate-50/70 shrink-0 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-[11px] font-black uppercase tracking-wider text-slate-500 mr-1">
                Bundles:
              </span>
              <span className="px-2 py-0.5 bg-white border border-slate-200 text-[11px] font-black font-mono text-primary shadow-2xs">
                {manualStickerRows.length} Rows
              </span>
              <span className="px-2 py-0.5 bg-white border border-slate-200 text-[11px] font-black font-mono text-slate-700 shadow-2xs">
                Total PCS: {manualStickerRows.reduce((sum, r) => sum + (Number(r.total_Pcs) || 0), 0).toLocaleString()}
              </span>
              <span className="px-2 py-0.5 bg-white border border-slate-200 text-[11px] font-black font-mono text-emerald-700 shadow-2xs">
                Total Wt: {manualStickerRows.reduce((sum, r) => sum + (parseFloat(r.total_Weight) || 0), 0).toFixed(2)} KG
              </span>
            </div>

            <div className="flex items-center gap-2 flex-wrap">
              <div className="flex items-center border border-slate-200 bg-white p-0.5">
                <button
                  type="button"
                  onClick={() => handleSetAllManualStickerBranding(true)}
                  className="px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-primary hover:bg-primary/5 transition-colors"
                  title="Check branding for all rows"
                >
                  All With Branding
                </button>
                <div className="h-4 w-[1px] bg-slate-200" />
                <button
                  type="button"
                  onClick={() => handleSetAllManualStickerBranding(false)}
                  className="px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-slate-600 hover:bg-slate-100 transition-colors"
                  title="Uncheck branding for all rows"
                >
                  All Without Branding
                </button>
              </div>

              <button
                type="button"
                onClick={() => handleAddManualStickerRow()}
                className="flex items-center gap-1 px-3 py-1.5 bg-primary text-white text-[10px] font-black uppercase tracking-wider hover:bg-primary/90 transition-all shadow-xs"
              >
                <MdAdd size={16} />
                Add Bundle
              </button>
            </div>
          </div>

          {/* Table Container */}
          <div className="flex-1 overflow-x-auto overflow-y-auto min-h-[280px] max-h-[58vh] bg-white">
            <table className="w-full text-left border-collapse min-w-[1080px]">
              <thead className="sticky top-0 z-20 bg-gray-50 shadow-[0_1px_0_0_#e2e8f0]">
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-10">#</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] w-32">Bundle No. *</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] w-48">Die No.</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] w-36">Profile Name</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-24">Total PCS</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-28">Total Weight</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-24">Cut Length</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] w-28">Unit</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-24">WT/Pcs</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-24">WT/12 FT</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-20">Branding</th>
                  <th className="px-2 py-2.5 text-[10px] font-black text-gray-500 uppercase tracking-[1px] text-center w-20">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {manualStickerRows.map((row, index) => {
                  return (
                    <tr key={index} className="hover:bg-slate-50/50 transition-colors">
                      {/* Row Index */}
                      <td className="px-2 py-2 text-center text-[11px] font-black text-slate-400 font-mono">
                        {index + 1}
                      </td>

                      {/* Bundle No */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="text"
                          required
                          value={row.bundle_No}
                          onChange={(e) => handleManualStickerRowChange(index, { bundle_No: e.target.value })}
                          placeholder="Bundle No."
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-bold font-mono focus:border-primary focus:bg-white outline-none transition-all rounded-none uppercase text-slate-800"
                        />
                      </td>

                      {/* Die No */}
                      <td className="px-1.5 py-1.5">
                        <Select
                          options={dieOptions}
                          value={dieOptions.find((d) => String(d.value) === String(row.die_Id)) || null}
                          onChange={(selected) => handleManualStickerRowChange(index, { die_Id: selected?.value || "" })}
                          placeholder="Select Die No."
                          isClearable
                          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                          menuPosition="fixed"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: '32px',
                              height: '32px',
                              fontSize: '12px',
                              borderRadius: '0',
                              borderColor: state.isFocused ? '#0F3D75' : '#e2e8f0',
                              backgroundColor: '#f9fafb',
                              boxShadow: 'none',
                              '&:hover': {
                                borderColor: '#0F3D75'
                              }
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              padding: '0 6px',
                              height: '32px',
                            }),
                            input: (base) => ({
                              ...base,
                              margin: 0,
                              padding: 0,
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: '32px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 99999,
                            }),
                          }}
                        />
                      </td>

                      {/* Profile Name */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="text"
                          value={row.profile_Name}
                          onChange={(e) => handleManualStickerRowChange(index, { profile_Name: e.target.value })}
                          placeholder="Profile Name"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-medium focus:border-primary focus:bg-white outline-none transition-all rounded-none text-slate-700"
                        />
                      </td>

                      {/* Total PCS */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="number"
                          value={row.total_Pcs}
                          onChange={(e) => handleManualStickerRowChange(index, { total_Pcs: e.target.value })}
                          placeholder="0"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black text-center font-mono focus:border-primary focus:bg-white outline-none transition-all rounded-none"
                        />
                      </td>

                      {/* Total Weight */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="number"
                          step="any"
                          value={row.total_Weight}
                          onChange={(e) => handleManualStickerRowChange(index, { total_Weight: e.target.value })}
                          placeholder="0.00"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black text-center font-mono text-emerald-700 focus:border-primary focus:bg-white outline-none transition-all rounded-none"
                        />
                      </td>

                      {/* Cut Length */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="number"
                          step="any"
                          value={row.cut_Length}
                          onChange={(e) => handleManualStickerRowChange(index, { cut_Length: e.target.value })}
                          placeholder="0.00"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black text-center font-mono focus:border-primary focus:bg-white outline-none transition-all rounded-none"
                        />
                      </td>

                      {/* Unit */}
                      <td className="px-1.5 py-1.5">
                        <select
                          value={row.unit_Conv_Id}
                          onChange={(e) => handleManualStickerRowChange(index, { unit_Conv_Id: e.target.value })}
                          className="w-full h-[32px] bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black focus:border-primary focus:bg-white outline-none transition-all rounded-none"
                        >
                          <option value="">Select...</option>
                          {unitOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* WT/Pcs */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="number"
                          step="any"
                          value={row.wT_Per_Pcs}
                          onChange={(e) => handleManualStickerRowChange(index, { wT_Per_Pcs: e.target.value })}
                          placeholder="0.000"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black text-center font-mono focus:border-primary focus:bg-white outline-none transition-all rounded-none text-slate-800"
                        />
                      </td>

                      {/* WT/12 FT */}
                      <td className="px-1.5 py-1.5">
                        <input
                          type="number"
                          step="any"
                          value={row.wT_12_FT}
                          onChange={(e) => handleManualStickerRowChange(index, { wT_12_FT: e.target.value })}
                          placeholder="0.000"
                          className="w-full bg-gray-50 border border-gray-200 px-2 py-1 text-[12px] font-black text-center font-mono focus:border-primary focus:bg-white outline-none transition-all rounded-none text-slate-800"
                        />
                      </td>

                      {/* Branding Checkbox */}
                      <td className="px-2 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={row.withBranding !== false}
                          onChange={(e) => handleManualStickerRowChange(index, { withBranding: e.target.checked })}
                          className="w-4 h-4 text-primary rounded-none border-gray-300 cursor-pointer accent-primary align-middle"
                          title={row.withBranding !== false ? "With Branding (checked)" : "Without Branding (unchecked)"}
                        />
                      </td>

                      {/* Actions */}
                      <td className="px-2 py-2 text-center">
                        <div className="flex items-center justify-center gap-1.5">
                          <button
                            type="button"
                            onClick={() => handleAddManualStickerRow(index)}
                            className="w-7 h-7 flex items-center justify-center rounded-full bg-emerald-50 text-emerald-600 hover:bg-emerald-500 hover:text-white transition-colors"
                            title="Add Row Below"
                          >
                            <MdAdd size={16} />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDeleteManualStickerRow(index)}
                            disabled={manualStickerRows.length === 1}
                            className={`w-7 h-7 flex items-center justify-center rounded-full transition-colors ${manualStickerRows.length === 1
                              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                              : "bg-red-50 text-red-500 hover:bg-red-500 hover:text-white"
                              }`}
                            title="Delete Row"
                          >
                            <MdDelete size={15} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Footer Bar */}
          <div className="p-4 px-6 border-t border-slate-100 bg-white shrink-0 flex flex-wrap items-center justify-end gap-3">

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => setIsManualStickerModalOpen(false)}
                className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors rounded-none"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading || manualStickerRows.length === 0}
                className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex items-center gap-2 shadow-sm rounded-none"
              >
                <MdPrint size={15} />
                {loading ? "Generating..." : `Print Stickers (${manualStickerRows.length})`}
              </button>
            </div>
          </div>
        </form>
      </Model>

      <TourGuide
        isOpen={isTourOpen}
        steps={PackingTourSteps}
        title="Packing Guide"
        model="Packing Module"
        onClose={() => {
          setIsTourOpen(false);
          handleTourComplete();
        }}
      />

      <Filter
        isOpen={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        filterFields={getFilterFields()}
        filters={tempFilters}
        setFilters={setTempFilters}
        applyFilters={handleApplyFilters}
        clearFilters={handleClearFilters}
      />
    </div>

  );
};

export default Packing;
